import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { motion } from "motion/react";

function PrivacyPolicyPage() {
  return (
    <div className="mx-auto w-full max-w-300 px-6 pt-4 pb-8 md:px-8 md:pt-6 md:pb-10 lg:px-12 lg:pt-8 lg:pb-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <img
            src="/assets/images/logo/logo_loanapp.png"
            alt="ASSETS ID"
            width={165}
            height={70}
          />
        </Box>

        <Typography
          variant="h1"
          className="mb-10 text-center text-4xl font-semibold leading-[1.25] tracking-tight md:text-6xl md:leading-none"
        >
          Privacy Policy
        </Typography>

        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          Thank you for visiting this web site. We understand the importance
          that Internet users place on privacy, and this Privacy Policy
          describes how we use personal information that is collected at this
          web site. Please read this Privacy Policy before using this site or
          submitting any personal information. By using this web site, you
          accept the privacy practices contained in this Privacy Policy. These
          privacy practices may change from time to time, but any changes will
          be posted. You are encouraged to review the Privacy Policy whenever
          you visit the web site to make sure you understand how any personal
          information you provide will be used.
        </Typography>

        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          INFORMATION WE COLLECT:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          In order to serve our customers, we collect personally identifiable
          information, like names, addresses, email addresses, and sometimes
          credit card information when such information is voluntarily submitted
          by our visitors. We will only use your personal information for the
          following purposes: (1) to deliver the products and/or services to you
          that you have requested; (2) to validate your compliance with the
          terms and conditions; (3) for content improvement and feedback
          purposes; and (4) to reach you, when necessary, regarding your use of
          the web site or product(s). With your permission, we may also access
          other personal information on your device, such as your phone book,
          calendar or messages, in order to provide services to you. If
          authorized by you, we may also access profile and other information
          from services like Facebook.
          <br /> <br />
          We will NEVER share your information with third parties unless you
          have given us explicit permission to do so, such as in order to
          fulfill a third party offer that you have accepted from us. By
          permitting us to collect this information, you will be able to receive
          free information on products and services that may be of interest to
          you, including related third party offers that we may send to you. You
          also enable us to personalize your experience with us so that we can
          provide you with the highest quality of service. By submitting your
          email address on this web site, you agree to receive email from us.
          You can cancel your participation in any of these email lists at any
          time by clicking the opt-out link or other unsubscribe option that is
          included in the respective email. We only send emails to people who
          have authorized us to contact them, either directly, or through a
          third party. We do not send unsolicited commercial emails, because we
          hate spam as much as you do.
          <br /> <br />
          In addition, you agree that by submitting your email address on this
          web site and/or registering to receive the product and/or service
          offered herein, such act constitutes a purchase, an inquiry, and/or an
          application for the purposes of the Amended Telemarketing Sales Rule
          (ATSR), 16 CFR '310 et seq. and any applicable state and local "do not
          call" regulations. We retain the right to contact you via
          telemarketing in accordance with the ATSR and the applicable state
          regulations.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          THIRD PARTY ACTIONS:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          We do not control and are not liable for the actions of any third
          parties who we may promote. We pride ourselves in working with quality
          companies, but have no control over the actions of those third
          parties. While we are not liable for any of the actions of those third
          parties, you should feel free to give us feedback from time to time on
          your experiences with any third parties to whom we work with so that
          we may enhance our future service to all customers.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          SERVICE PROVIDERS:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          We may employ third-party companies and individuals due to the
          following reasons:
          <ul>
            <li>To facilitate our Service;</li>
            <li>To provide the Service on our behalf;</li>
            <li>To perform Service-related services; or</li>
            <li>To assist us in analyzing how our Service is used.</li>
          </ul>
          <br /> <br />
          We want to inform our Service users that these third parties have
          access to your Personal Information. The reason is to perform the
          tasks assigned to them on our behalf. However, they are obligated not
          to disclose or use the information for any other purpose.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          DATA RETENTION:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          Your data is retained as long as necessary to provide services, fulfill legal obligations, and maintain records. After that, it is deleted or anonymized.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          COOKIES:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          We may use cookies to deliver content that is specific to your
          interests. Cookies are text files that are used by your computer's web
          browser to store your preferences, and enable us to enhance your user
          experience with our web site.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          IP ADDRESSES:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          We may use your IP address to help prevent fraud, to help diagnose
          problems with our server, to gather broad demographic information, and
          to offer you products and services.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          THIRD PARTY WEB SITES:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          This web site and/or the products and/or services offered herein may
          direct you to web sites that are owned and/or controlled by third
          parties. We have no control over those third parties and are not
          responsible for the content or the privacy practices of those sites or
          companies.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          COMMITMENT TO DATA SECURITY:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          All information collected from you is stored in a technically and
          physically secure environment. We use SSL encryption to protect
          sensitive information online, and we do everything we can to protect
          user information offline. Unfortunately, no transmission over the
          Internet can be guaranteed to be 100% secure. As a result, while we
          take reasonable measures to protect your information, we cannot ensure
          or warrant the security of the information that you transmit to us,
          and you do so at your own risk.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          HOW DO WE STORE YOUR INFORMATION?
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          Your information is stored at the list server that delivers AssetsID
          messages or content. Your information can only be accessed by those
          who help manage those lists in order to deliver e-mail to those who
          would like to receive AssetsID newsletters.
          <br /> <br />
          All of the newsletters or emails that are sent to you by AssetsID
          include an unsubscribe link in them. You can remove yourself at any
          time from our newsletters or mailing list by clicking on the
          unsubscribe link that can be found in every communication that we send
          you.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          ACCOUNT DELETION REQUEST:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          To delete your account and all associated data, email us at:
          <br />
          <a
            href="mailto:support@assetsid.com"
            rel="noopener noreferrer"
          >
            support@assetsid.com
          </a>
          <br /> <br />
          Include your registered email or account ID. We will process your request within 30 days.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          CONTACTING US
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          If you need to contact us, you can email us at{" "}
          <a
            href="mailto:support@assetsid.com"
            rel="noopener noreferrer"
          >
            support@assetsid.com
          </a>
          <br /> <br />
          We strive to provide excellent products, along with equally excellent
          customer service. If you have any questions about this Privacy Policy
          or our practices, please feel free to contact us.
        </Typography>
      </motion.div>
    </div>
  );
}

export default PrivacyPolicyPage;
